/**
 * Ferreti FOMO Live Purchases Notification Popup
 */
(function () {
  const buyers = [
    { name: 'Carlos', city: 'Dallas, TX' },
    { name: 'Alejandro', city: 'Houston, TX' },
    { name: 'Miguel', city: 'San Antonio, TX' },
    { name: 'Javier', city: 'Los Angeles, CA' },
    { name: 'Daniel', city: 'Phoenix, AZ' },
    { name: 'Eduardo', city: 'El Paso, TX' },
    { name: 'Jorge', city: 'Miami, FL' },
    { name: 'Luis', city: 'Chicago, IL' },
    { name: 'Roberto', city: 'Las Vegas, NV' },
    { name: 'Gabriel', city: 'Austin, TX' },
    { name: 'Fernando', city: 'Denver, CO' },
    { name: 'Ricardo', city: 'San Diego, CA' },
    { name: 'Hector', city: 'Orlando, FL' },
    { name: 'Adrian', city: 'Atlanta, GA' },
    { name: 'Marco', city: 'Albuquerque, NM' },
    { name: 'Victor', city: 'McAllen, TX' },
    { name: 'Sergio', city: 'Fresno, CA' },
    { name: 'David', city: 'Laredo, TX' },
    { name: 'Raúl', city: 'Tucson, AZ' },
    { name: 'Iván', city: 'Charlotte, NC' },
    { name: 'Ángel', city: 'Riverside, CA' },
    { name: 'Mario', city: 'Fort Worth, TX' },
    { name: 'Diego', city: 'San Jose, CA' },
    { name: 'Oscar', city: 'Tampa, FL' }
  ];

  const times = [
    'Hace 2 min',
    'Hace 4 min',
    'Hace 6 min',
    'Hace 9 min',
    'Hace 14 min',
    'Hace 22 min',
    'Hace 35 min'
  ];

  function cleanTitle(title) {
    if (!title) return '';
    return title
      .replace(/^FERRETI\s+HATS\s+PREMIUM\s+/i, '')
      .replace(/^FERRETI\s+HATS\s+/i, '')
      .replace(/^FERRETI\s+/i, '')
      .replace(/\s+with\s+iconic.*$/i, '')
      .trim();
  }

  function initFomo() {
    const root = document.getElementById('ferreti-fomo-popup');
    const productsScript = document.getElementById('ferreti-fomo-products');
    if (!root || !productsScript) return;

    let products = [];
    try {
      products = JSON.parse(productsScript.textContent || '[]');
    } catch (e) {
      console.warn('Ferreti FOMO parse error:', e);
      return;
    }

    if (!products.length) return;

    const imgEl = root.querySelector('[data-fomo-img]');
    const buyerEl = root.querySelector('[data-fomo-buyer]');
    const productEl = root.querySelector('[data-fomo-product]');
    const timeEl = root.querySelector('[data-fomo-time]');
    const linkEl = root.querySelector('[data-fomo-link]');
    const closeBtn = root.querySelector('[data-fomo-close]');

    let isDismissed = false;
    let timeoutId = null;

    closeBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      isDismissed = true;
      if (timeoutId) clearTimeout(timeoutId);
      // Re-enable after 60 seconds of silence
      setTimeout(() => {
        isDismissed = false;
        scheduleNext();
      }, 60000);
    });

    function showNotification() {
      if (isDismissed) return;

      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      const randomProduct = products[Math.floor(Math.random() * products.length)];
      const randomTime = times[Math.floor(Math.random() * times.length)];

      if (buyerEl) buyerEl.textContent = `${randomBuyer.name} (${randomBuyer.city})`;
      if (productEl) productEl.textContent = cleanTitle(randomProduct.title);
      if (timeEl) timeEl.textContent = randomTime;
      if (imgEl && randomProduct.image) {
        imgEl.src = randomProduct.image;
        imgEl.alt = randomProduct.title;
      }
      if (linkEl && randomProduct.url) {
        linkEl.href = randomProduct.url;
      }

      root.classList.add('is-visible');
      root.setAttribute('aria-hidden', 'false');

      // Stay visible for 5 seconds
      timeoutId = setTimeout(() => {
        root.classList.remove('is-visible');
        root.setAttribute('aria-hidden', 'true');
        scheduleNext();
      }, 5000);
    }

    function scheduleNext() {
      if (isDismissed) return;
      // Pause for 10 seconds before next
      timeoutId = setTimeout(showNotification, 10000);
    }

    // First trigger after 4 seconds
    setTimeout(showNotification, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFomo);
  } else {
    initFomo();
  }
})();
